import { useState } from 'react';

import { useFloatingResourceAddContext } from 'hooks/useFloatingResourceAddContext';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const FloatingResourceAddProvider: FunctionComponent<Props> = ({ children, testId = TEST_ID }) => {
    const [visible, setVisible] = useState(true);
    const { context } = useFloatingResourceAddContext();

    return (
        <context.Provider data-testid={testId} value={{ setVisible, visible }}>
            {children}
        </context.Provider>
    );
};

FloatingResourceAddProvider.displayName = 'FloatingResourceAddProvider';

export default FloatingResourceAddProvider;
